import { axiosWithBaseUrl } from '@/api/axios'
import { setCurrentUser, getCurrentUser, setToken } from '@/utils'
import { nanoid } from 'nanoid'
import router from '@/router'

const state = () => ({
  currentUser: getCurrentUser() ? getCurrentUser() : null,
  loginError: null,
  processing: false,
  forgotMailSuccess: null,
  resetPasswordSuccess: null
})

const getters = {
  currentUser: (state) => state.currentUser,
  processing: (state) => state.processing,
  loginError: (state) => state.loginError,
  forgotMailSuccess: (state) => state.forgotMailSuccess,
  resetPasswordSuccess: (state) => state.resetPasswordSuccess
}

const mutations = {
  setUser(state, payload) {
    state.currentUser = payload
    state.processing = false
    state.loginError = null
  },
  setLogout(state) {
    state.currentUser = null
    state.processing = false
    state.loginError = null
  },
  setProcessing(state, payload) {
    state.processing = payload
    state.loginError = null
  },
  setError(state, payload) {
    state.loginError = payload
    state.currentUser = null
    state.processing = false
  },
  setForgotMailSuccess(state) {
    state.loginError = null
    state.currentUser = null
    state.processing = false
    state.forgotMailSuccess = true
  },
  setResetPasswordSuccess(state) {
    state.loginError = null
    state.currentUser = null
    state.processing = false
    state.resetPasswordSuccess = true
  },
  clearError(state) {
    state.loginError = null
  }
}

const actions = {
  login({ commit }, { payload, vm }) {
    commit('clearError')
    commit('setProcessing', true)
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    axiosWithBaseUrl
      .post('/api/auth/login', data, config)
      .then((res) => {
        const token = res.data.token
        setToken(token)

        const user = { name: 'admin', id: nanoid() }
        setCurrentUser(user)
        commit('setUser', user)
        vm.$router.push('/')
      })
      .catch((err) => {
        setCurrentUser(null)
        commit('setError', err.message)
        setTimeout(() => {
          commit('clearError')
        }, 3000)
      })
  },
  signOut({ commit }) {
    commit('setLogout')
    setToken(null)
    setCurrentUser(null)
    router.push('/auth/login')
  },
  requestAuthError({ commit }, error) {
    if (error && error.response) {
      if (error.response.status === 401) {
        commit('setLogout')
        setCurrentUser(null)
        setToken(null)
        router.push('/auth/login')
      } else if (error.response.status === 403) {
        router.push('/')
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
